import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import Slick from 'vue-slick';
import { mapGetters } from 'vuex';
var namespace = 'shopmenu-store';
export default {
  store: store,
  components: {
    Slick: Slick
  },
  data: function data() {
    return {
      // Vue-Slick の設定
      slickOptions: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        speed: 700,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        pauseOnFocus: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters('app', ['h']), {}, mapGetters(namespace, ['recommendList'])),
  methods: {
    // Slick 内のコンテンツを v-for で出力直後は表示不具合があるので、
    // watch と併用して再描画のメソッドを投げる
    reInit: function reInit() {
      var _this = this;

      this.$refs.slick.destroy();
      this.$nextTick(function () {
        _this.$refs.slick.create();

        _this.$refs.slick.goTo(0, true);
      });
    }
  },
  watch: {
    recommendList: function recommendList() {
      // console.log('Slick 再描画');
      this.reInit();
    }
  }
};